import { getMonthFromStart } from '../utils/time.js';
import { sortByDateLatest } from '../utils/sort.js';

export const options = getMonthFromStart().sort(sortByDateLatest(getMonthFromStart())).map(obj => ( 
  { value: obj, label: obj }
));



// WEBPACK FOOTER //
// ./src/const/date.js